import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Divider, Grid, IconButton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";

import logoTop from "../../src/components/common/svgs/logoTop.svg";
import CommonButton from "../components/common/button/Button";
import CommonInput from "../components/common/input/InputBox";
import useSnackbarAlert from "../utils/snackbarHandlers";

const ForgotPassword: React.FC<any> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  const [loading, setLoading] = React.useState<boolean>(false);
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();

  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";

  const validationSchema = yup.object().shape({
    email: yup.string().email(t("invalidEmail")).required(t("emailRequired")),
  });

  const onHandleSubmit = (value: any) => {
    setLoading(true);
    const body = {
      email: value.email,
    };

    axios
      .put(`${apiBaseURL}/api/users/forgotPassword`, body)
      .then((response) => {
        console.log("Forgot password response", response);
        showSuccessMessage(response.data.message);
      })
      .catch((err: any) => {
        showErrorMessage(err?.response?.data?.message ?? t("emailDoesnotExist"));
        console.log("Forgot password error - ", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: onHandleSubmit,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });
  const { values, errors, handleSubmit, handleChange } = formik;

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  };

  return (
    <Grid container className='flex flex-col justify-between min-h-screen'>
      {/* Start of header */}
      <header className='bg-[#074470] text-white p-4'>
        <div className='container mx-auto flex justify-center'>
          {/* <h1 className="text-2xl font-bold">Digi Tech Express</h1> */}
          <img src={logoTop} alt='logo top' height='30%' width='auto' onClick={() => navigate('/')} />
        </div>
      </header>
      {/* End of header */}

      {/* Start of forgot form */}
      <Grid className='flex justify-center items-center flex-grow bg-[#E9E7FF]'>
        {/* {loading ? <Grid className="flex justify-center w-full absolute z-[100]"><CircularProgress /></Grid> : null} */}
        <Grid item xs={12} sm={10} md={8} lg={6} className='flex flex-col gap-[15px] w-[40%] mb-[5%] scale-[0.8]'>
          {/* <Grid className="text-4xl font-[700] flex justify-center font-['IBM_Plex_Sans']">
          {t("lotterySystem")}
        </Grid> */}
          <Grid className="bg-white rounded-[20px] py-[4%] font-['Baloo_2']">
            <Grid className='flex justify-center w-full text-center'>
              <Grid className='text-3xl font-[700] text-[#074470] w-[90%]'>
                {t("forgotYourPassword")}
              </Grid>
            </Grid>
            <Grid className='flex justify-center w-full'>
              <Grid className='text-lg font-[400] w-[90%] text-[#474646]'>
                {t("resetPasswordConfirmation")}
              </Grid>
            </Grid>
            <Grid className='w-full flex justify-center mt-4'>
              <Grid className='w-[90%]'>
                <CommonInput
                  id='email-id-input-box'
                  fullWidth
                  name='email'
                  label={t("email")}
                  placeholder={t("emailAddress")}
                  value={values?.email}
                  onChange={handleChange}
                  error={errors?.email ? true : false}
                  helperText={errors?.email}
                  className='login-input-box'
                />
              </Grid>
            </Grid>
            <Grid className='w-full flex justify-center'>
              <Grid className='w-[90%]'>
                <CommonButton
                  id='login-button'
                  className='login-button'
                  variant='contained'
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={loading}
                  ignoreButtonRootClass={true}
                  style={{
                    backgroundColor: "#F17400",
                    height: "2.5rem",
                  }}
                >
                  {t("sendCode")}

                  {loading && (
                    <CircularProgress
                      color='inherit'
                      size={14}
                      thickness={6}
                      style={{ marginLeft: "8px" }}
                    />
                  )}
                </CommonButton>
              </Grid>
            </Grid>

            <Divider className='my-4 w-[90%] ml-[5%]' />

            <Grid className='flex justify-center items-center'>
              <span className='flex-grow text-center mr-2 text-xl'>{t("rememberYourPassword")}</span>
              <CommonButton
                id='contact-us-button'
                variant='outlined'
                size='large'
                style={{
                  minWidth: "auto",
                  padding: "4px 8px",
                  width: "30%",
                  borderColor: "black",
                  color: "black",
                  marginRight: "5%",
                  borderRadius: "10px",
                }}
                onClick={(e) => navigate("/login")}
                ignoreButtonRootClass={true}
              >
                {t("logIn")}
              </CommonButton>
            </Grid>

            {/* <Grid className='flex justify-center w-full mt-[8%]'>
              <Grid className='flex justify-between w-[90%] items-baseline'>
                <Grid className='text-[#474646] h-full'>{t("rememberYourPassword")}</Grid>
                <Grid>
                  <CommonButton
                    id='login-button'
                    onClick={(e) => navigate("/login")}
                    className='sign-up-button'
                    variant='outlined'
                  >
                    {t("logIn")}
                  </CommonButton>
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
      {/* End of forgot form */}

      {/* Start of footer */}
      {/* Footer */}
      <footer className='bg-[#074470] text-white p-0 mt-auto'>
        <div className='container mx-auto flex justify-between items-center'>
          <p className='text-center'>
            Copyright &copy; 2024-2030 Digi Tech Express | All Rights Reserved
          </p>
          <div className='flex gap-4'>
            <IconButton
              aria-label='Facebook'
              color='inherit'
              size='small'
              onClick={() => openInNewTab("https://www.facebook.com/profile.php?id=61556226006007")}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              aria-label='Twitter'
              color='inherit'
              size='small'
              onClick={() => openInNewTab("https://www.instagram.com/digitech.express")}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              aria-label='LinkedIn'
              color='inherit'
              size='small'
              onClick={() => openInNewTab("https://www.youtube.com/@digitechexpress")}
            >
              <YouTubeIcon />
            </IconButton>
          </div>
        </div>
      </footer>
      {/* End of footer */}
    </Grid>
  );
};

export default ForgotPassword;
